const avatarFormEquip = {
  photo: 'PHOTO'
};

export default avatarFormEquip;
